import { useContext } from 'react';

import { StoreContext } from '../stores/helpers/store-provider';
import { RootStoreModel } from '../stores/root-store';

export const useStore = (): RootStoreModel => useContext(StoreContext);
